// extracted by mini-css-extract-plugin
export default {"disabledFormOverlay":"dF3Dv0"};